import React from "react";
import {Box, Button, Columns, Form, Heading} from "react-bulma-components";




export default function CashSaleSection({data, index, onChange}){
    // it expects onChange to take event and index
    return (
        <Box>
            <Columns>
                <Columns.Column>
                    <Form.Label>Name (*)</Form.Label>
                    <Form.Input
                        type={"text"}
                        name={"name"}
                        value={data.name}
                        onChange={e => onChange(e, index)}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Email</Form.Label>
                    <Form.Input
                        type={"email"}
                        name={"email"}
                        value={data.email}
                        onChange={e => onChange(e, index)}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Input
                        name={"phone"}
                        value={data.phone}
                        onChange={e => onChange(e, index)}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Address (*)</Form.Label>
                    <Form.Input
                        name={"address"}
                        value={data.address}
                        onChange={e => onChange(e, index)}
                    />
                </Columns.Column>
            </Columns>
        </Box>

    )



}